import { isValidElement } from "react";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import { slugifyHeading } from "../../utils/policyMarkdown";

// No rehype-raw / dangerouslySetInnerHTML — react-markdown does not render
// embedded raw HTML by default, which is exactly the safe posture policy
// content (repository-controlled, but no reason to widen the rendering
// attack surface) should have.

// react-markdown v5 hands a heading renderer an array of already-wrapped
// React elements (each inline child, even plain text, comes through as its
// own internal TextRenderer element), not raw strings — recurse through
// `.props.children` to get the actual visible text, so a heading's slug is
// computed from what a reader actually sees.
function headingText(node) {
  if (typeof node === "string") return node;
  if (Array.isArray(node)) return node.map(headingText).join("");
  if (isValidElement(node)) return headingText(node.props.children);
  return "";
}

function Heading(props) {
  const Tag = `h${props.level}`;
  return <Tag id={slugifyHeading(headingText(props.children))}>{props.children}</Tag>;
}

function MarkdownLink({ href, children }) {
  if (href?.startsWith("/")) return <Link to={href}>{children}</Link>;
  const external = /^https?:\/\//.test(href ?? "");
  return (
    <a href={href} {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}>
      {children}
    </a>
  );
}

function Blockquote(props) {
  return <blockquote className="policy-callout">{props.children}</blockquote>;
}

const RENDERERS = {
  heading: Heading,
  link: MarkdownLink,
  blockquote: Blockquote,
};

export default function MarkdownPolicyDocument({ markdown }) {
  return <ReactMarkdown renderers={RENDERERS}>{markdown}</ReactMarkdown>;
}
